import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['input', 'suggestions'];

  show() {
    if (!this.hasSuggestionsTarget) return;
    if (this.inputTarget.value !== '') return;

    this.suggestionsTarget.hidden = false;
  }

  delayedHide() {
    this._hideTimeout = setTimeout(() => {
      this.hide();
    }, 150);
  }

  hide() {
    if (!this.hasSuggestionsTarget) return;
    this.suggestionsTarget.hidden = true;
  }

  select(event) {
    event.preventDefault();
    const { url } = event.currentTarget.dataset;
    if (url) {
      this.inputTarget.value = url;
    }
    this.hide();
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }
  }

  disconnect() {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }
  }
}
